import React, {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {useRouteMatch} from 'react-router-dom'
import useEegSummaryReport from 'features/analysis/useEegSummaryReport'
import {EEGSummaryResponseWithClient} from 'api/analysisApi'
import NoneProfitSummary from 'components/molcules/N1SummaryReport/EEG/EEGSummary'
import NoneChildProfitSummary from 'components/molcules/N1SummaryReport/EEGChild/EEGSummary'
import ProfitSummary from 'components/molcules/ProfitSummaryReport/EEG/EEGSummary'
import ProfitChildSummary from 'components/molcules/ProfitSummaryReport/EEGChild/EEGSummary'
import HeaderV1 from 'pages/HealthCenter/Report/Elements/HeaderV1'
import {GenderValue, toGenderString} from 'constants/CommonConstant'
import useStyles from 'pages/Analysis/EEGSummary/Report/style'

interface BrainFunctionMappingProps {
  setPathPDF: (path: string) => void
  setIsChild: (isChild: boolean) => void
}
const BrainFunctionMapping = ({
  setPathPDF,
  setIsChild,
}: BrainFunctionMappingProps) => {
  const {t, i18n} = useTranslation()

  const {
    params: {id},
  } = useRouteMatch<{id: string}>()

  const [titleHeader, setTitleHeader] = useState<string>('')
  const [report, setReport] = useState<EEGSummaryResponseWithClient>()

  const {itemsBrainFunctionMapping: items, getReportBrainFunctionMapping} =
    useEegSummaryReport()

  const classes = useStyles()
  const isSummary = true

  useEffect(() => {
    if (items) {
      setPathPDF(items[0]?.finalReportPath ?? '')
      setReport(items[0])
      const age = items[0]?.client?.treatmentAge ?? 0
      if (age >= 20) {
        setTitleHeader(String(t('IEEGSummaryReport')))
        setIsChild(true)
      } else {
        setTitleHeader(String(t('IEEGChildSummaryReport')))
        setIsChild(false)
      }
    }
  }, [items])

  useEffect(() => {
    const param = {
      lang: i18n.language,
      summaryIds: [Number.parseInt(id, 10)],
      summaryLang: i18n.language as LanguageCode,
    }
    getReportBrainFunctionMapping(param)
  }, [i18n.language])
  return (
    <>
      <HeaderV1
        title={titleHeader}
        content={t('IEEGSummarySubTitle')}
        name={t('IGetFullName', {
          firstName: report?.client.clientFirstName ?? '',
          lastName: report?.client.clientLastName ?? '',
        })}
        sex={
          report
            ? t(toGenderString(report.client.clientGender as GenderValue))
            : ''
        }
        birthday={report ? report.client.clientBirth : ''}
        measurementDate={report ? (report.treatmentAt as string) : ''}
      />

      <div className={classes.brainBasic}>
        {report !== undefined &&
          report.reportType === 'N1' &&
          report.client.treatmentAge >= 20 && (
            <NoneProfitSummary {...report} isSummary={isSummary} />
          )}
        {report !== undefined &&
          report.reportType !== 'N1' &&
          report.client.treatmentAge >= 20 && (
            <ProfitSummary {...report} isSummary={isSummary} />
          )}
        {report !== undefined &&
          report.reportType === 'N1' &&
          report.client.treatmentAge < 20 && (
            <NoneChildProfitSummary
              {...report}
              client={report.client}
              isSummary={isSummary}
            />
          )}
        {report !== undefined &&
          report.reportType !== 'N1' &&
          report.client.treatmentAge < 20 && (
            <ProfitChildSummary
              {...report}
              client={report.client}
              isSummary={isSummary}
            />
          )}
      </div>
    </>
  )
}

export default BrainFunctionMapping
